import { render, staticRenderFns } from "./DiyNewDashboard.vue?vue&type=template&id=7304625e&scoped=true"
import script from "./DiyNewDashboard.vue?vue&type=script&lang=js"
export * from "./DiyNewDashboard.vue?vue&type=script&lang=js"
import style0 from "./DiyNewDashboard.vue?vue&type=style&index=0&id=7304625e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7304625e",
  null
  
)

export default component.exports